import RedirectForm from './RedirectForm';

export default RedirectForm;
